<template>
	<div class="w-100" ref="sectionRoot">
		<section class="d-flex align-items-center justify-content-between w-100">
			<div class="fam-mont fw-M fs-16 color-6A6A6A mob-fs-14 text-uppercase">
				Recommended Jobs
			</div>
			<div
				class="fam-mont fw-M fs-13 color-6A6A6A pointer"
				@click="$router.push({ name: 'JobSearch' })"
			>
				View All
				<img
					src="../../assets/NewDashboard/rightarrow.svg"
					style="margin-bottom: 2px"
					alt=""
				/>
			</div>
		</section>
		<div
			class="position-relative mob-mt-16px"
			@mouseenter="isHovered = true"
			@mouseleave="isHovered = false"
		>
			<div
				id="hideinmobile"
				v-show="isHovered && canScrollLeft"
				class="aimock-interview-arws left"
				@click.stop="scrollJobs('left')"
			>
				<img src="../../assets/NewDashboard/light-bluearrow.svg" alt="" />
			</div>
			<div
				id="hideinmobile"
				v-show="isHovered && canScrollRight"
				class="aimock-interview-arws right"
				@click.stop="scrollJobs('right')"
			>
				<img src="../../assets/NewDashboard/light-bluearrow.svg" alt="" />
			</div>
			<section
				ref="jobsScroll"
				class="mt-16px d-flex align-items-center gap-16px overflow-y-hidden overflow-x-auto invisible-scroll jobs-snap-scroll"
				@scroll.passive="onJobsScroll"
			>
				<!-- Loading skeleton -->
				<template v-if="isLoading">
					<div
						class="nlp-job-cards jobs-snap-item"
						v-for="i in 3"
						:key="'job-sk-' + i"
					>
						<section
							class="d-flex align-items-start justify-content-between w-100"
						>
							<div class="d-flex align-items-center gap-12px w-75 mob-w-unset">
								<b-skeleton
									type="avatar"
									size="44px"
									class="flex-shrink-0"
									style="border-radius: 40px"
								></b-skeleton>
								<div class="w-90" id="hideinmobile">
									<b-skeleton
										width="70%"
										height="16px"
										class="mb-1"
									></b-skeleton>
									<b-skeleton width="50%" height="13px"></b-skeleton>
								</div>
							</div>
							<div>
								<b-skeleton
									width="75px"
									height="26px"
									style="border-radius: 32px"
								></b-skeleton>
							</div>
						</section>
						<section id="hideinlaptop" class="mobmt-8px">
							<b-skeleton width="70%" height="15px" class="mb-1"></b-skeleton>
							<b-skeleton width="50%" height="12px"></b-skeleton>
						</section>
						<section
							class="d-flex mob-align-start align-items-center mob-flex-col justify-content-between w-100 mobmt-4px mt-10px"
						>
							<div class="d-flex align-items-center gap-16px">
								<b-skeleton
									width="65px"
									height="22px"
									style="border-radius: 4px"
								></b-skeleton>
								<b-skeleton
									width="75px"
									height="22px"
									style="border-radius: 4px"
								></b-skeleton>
							</div>
							<b-skeleton
								width="90px"
								height="14px"
								class="mobmt-4px"
							></b-skeleton>
						</section>
						<section class="mt-10px d-flex align-items-center gap-16px">
							<b-skeleton
								type="button"
								class="w-90"
								height="40px"
								style="border-radius: 200px"
							></b-skeleton>
							<b-skeleton
								type="avatar"
								size="40px"
								style="border-radius: 100px"
								class="flex-shrink-0"
							></b-skeleton>
						</section>
					</div>
				</template>

				<!-- Actual cards -->
				<template v-else>
					<div
						class="nlp-job-cards jobs-snap-item pointer"
						v-for="(job, index) in jobsList"
						:key="job.jobID || index"
						@click="routeToJobDetails(job)"
					>
						<section
							class="d-flex align-items-start justify-content-between w-100"
						>
							<div class="d-flex align-items-center gap-12px w-70 mob-w-unset">
								<div class="w-20">
									<div class="jobs-icon-container">
										<img src="../../assets/NewDashboard/jobs.svg" alt="" />
									</div>
								</div>
								<div class="w-90" id="hideinmobile">
									<div
										class="fam-mont fs-15 fw-B color-1F1F1F text-capitalize w-90 text-truncate"
									>
										{{ job.title }}
									</div>
									<div
										class="color-6573A2 fam-mont fw-M fs-13 w-100 d-flex align-items-center"
									>
										<span class="company-name text-truncate">
											{{ job.customerName }}
										</span>

										<div class="company-location-dot"></div>

										<span class="location-name text-truncate">
											{{ formatLocation(job.location) }}
										</span>
									</div>
								</div>
							</div>
							<div>
								<div
									v-if="job.matchScore"
									class="nlp-job-matchtag fam-mont mob-fs-10 fw-B fs-12 color-newblue"
								>
									{{ Math.round(job.matchScore * 100) }}% Match
								</div>
								<div
									v-if="job.activelyHiring"
									class="mobmt-4px fam-mont fw-M fs-10 color-green d-flex align-items-center gap-5px"
								>
									<img
										src="../../assets/NewDashboard/greendot.svg"
										style="padding-bottom: 1.5px"
										alt=""
									/>
									Actively Hiring
								</div>
							</div>
						</section>
						<section id="hideinlaptop">
							<div class="w-100 mobmt-8px">
								<div
									class="fam-mont fs-14 fw-B color-1F1F1F text-capitalize w-100 text-truncate"
								>
									{{ job.title }}
								</div>
								<div
									class="mobmt-4px color-6573A2 fam-mont fw-M fs-12 w-100 d-flex align-items-center"
								>
									<span class="company-name text-truncate">
										{{ job.customerName }}
									</span>

									<div class="company-location-dot"></div>

									<span class="location-name text-truncate">
										{{ formatLocation(job.location) }}
									</span>
								</div>
							</div>
						</section>
						<section
							class="d-flex mob-align-start align-items-center mob-flex-col justify-content-between w-100 mobmt-4px mt-10px color-6573A2 fw-LM fam-mont fs-13"
						>
							<div class="d-flex align-items-center gap-16px text-capitalize">
								<div
									class="jc-white-tags text-truncate"
									style="min-width: auto; max-width: 108px"
								>
									{{ job.jobType }}
								</div>
								<div v-if="job.experienceRequired" class="jc-white-tags">
									{{ job.experienceRequired }}&nbsp;Yrs Exp
								</div>
							</div>
							<div class="mobmt-4px">
								<img
									src="../../assets/NewDashboard/duration.svg"
									class="mr-1 pb-2px"
									alt=""
								/>{{ getPostedText(job) }}
							</div>
						</section>
						<section class="mt-10px d-flex align-items-center gap-16px">
							<button
								v-if="!job.jobApplied && !job.addedByRecruiter"
								class="new-light-blue-btn fam-mont text-white fw-M fs-14 text-center w-90 pointer lapapplynow"
								@click.stop="onApplyClick(job)"

							>
								Apply Now
								<img
									src="../../assets/NewDashboard/whitedirection-arw.svg"
									alt=""
								/>
							</button>
							<button
								v-else
								class="new-light-blue-btn fam-mont text-white fw-M fs-14 text-center w-90"
								@click.stop="routeToJobDetails(job)"
							>
								Applied
							</button>
							<div
								@click.stop="toggleJobBookmark(job)"
								class="jobcard-bookmark-container d-flex align-items-center justify-content-center pointer"
							>
								<img
									v-if="job.bookmarked"
									src="../../assets/NewDashboard/active-bookmark.svg"
									alt=""
								/>

								<img
									v-else
									src="../../assets/NewDashboard/bookmark.svg"
									alt=""
								/>
							</div>
						</section>
					</div>
				</template>
			</section>
			<!-- sliding dot indicator — mobile only -->
			<div
				id="hideinlaptop"
				class="jobs-dot-viewport"
				v-if="!isLoading && jobsList.length > 1"
			>
				<div class="jobs-dot-track" :style="dotTrackStyle">
					<span
						v-for="(job, i) in jobsList"
						:key="i"
						:class="[
							'jobs-dot',
							i === activeJobIndex ? 'jobs-dot--active' : 'jobs-dot--small',
						]"
					>
						<!-- <template v-if="i === activeJobIndex"
							>{{ activeJobIndex + 1 }}/{{ jobsList.length }}</template
						> -->
					</span>
				</div>
			</div>
		</div>
	</div>
	<!-- <b-container class="jobs-container">
	
		<header
			class="d-flex align-items-center justify-content-between dotted-bottom"
		>
			<div>
				<h2 class="fam-mont fw-M fs-16 mob-fs-14">Recommended Jobs</h2>
				<p class="fam-lato fw-R fs-14 mob-fs-12 text-secondary mb-0">
					Jobs that match your profile and skill set
				</p>
			</div>
			<nav
				class="fam-mont fw-M fs-14 mob-fs-13 text-blue d-flex align-items-center pointer"
				aria-label="View all recommended jobs"
				@click="$router.push({ name: 'JobSearch' })"
			>
				View All<img
					class="ml-2"
					src="../../assets/newdesign/home/blueRightArrow.svg"
					alt="Go to all jobs"
				/>
			</nav>
		</header>
=
		<div v-if="isLoading" class="mob-hor-job-scroll">
			<div v-for="i in 3" :key="'jobshim' + i" class="job-match-card mt-3">
				<aside class="match-percentage-bar" style="background-color: #f0f2f5">
					<b-skeleton height="60px" width="10px"></b-skeleton>
				</aside>
				<article class="match-card-content width-95">
					<div class="d-flex justify-content-between align-items-start">
						<div class="w-75">
							<b-skeleton width="80%"></b-skeleton>
							<b-skeleton width="50%" class="mt-2"></b-skeleton>
						</div>
						<b-skeleton type="avatar" size="24px"></b-skeleton>
					</div>
					<footer class="d-flex justify-content-between align-items-end mt-4">
						<div class="d-flex align-items-center gap-2 w-75">
							<b-skeleton width="25%"></b-skeleton>
							<b-skeleton width="25%"></b-skeleton>
							<b-skeleton width="25%"></b-skeleton>
						</div>
						<b-skeleton
							type="button"
							width="80px"
							height="36px"
							id="hideinmobile"
						></b-skeleton>
					</footer>
				</article>
			</div>
		</div>

		<div
			v-else
			class="mob-hor-job-scroll"
			role="list"
			ref="jobsScrollContainer"
		>
			<div
				v-for="(job, index) in jobsList"
				:key="job.jobID || index"
				class="job-match-card mt-3"
				@click="routeToJobDetails(job)"
			>
				<aside
					v-if="job.matchScore !== null && job.matchScore !== undefined"
					class="match-percentage-bar"
					aria-label="Job match percentage"
				>
					<span class="match-percentage-text fam-mont"
						>{{ Math.round(job.matchScore * 100) }}% Match</span
					>
				</aside>

				<article class="match-card-content width-95">
					<div class="d-flex justify-content-between align-items-start">
						<div
							:class="
								job.matchScore !== null && job.matchScore !== undefined
									? 'calc-wid-1'
									: 'calc-wid-2'
							"
						>
							<h3 class="fam-mont fw-M job-match-title w-100 text-truncate">
								{{ toSentenceCase(job.title) }}
							</h3>
							<p class="fam-lato fw-R fs-15 mob-fs-12 match-comp mb-0">
								{{ toSentenceCase(job.customerName) }}
							</p>
							<div id="hideinmobile" class="d-flex gap-2 mt-2">
								<span class="fam-lato fw-LM fs-14">Skills:</span>
								<p
									class="fam-lato fw-LM fs-14 text-lightgrey mb-0 text-truncate"
								>
									{{
										(job.skills || []).map((s) => toSentenceCase(s)).join(", ")
									}}
								</p>
							</div>
						</div>

						<div class="d-flex align-items-center gap-3">
							<div id="hideinmobile" class="fast-filling-badge" v-if="job.fastFillingJob">
								<img
									src="../../assets/newdesign/jobsearch/fastfilling.svg"
									style="width: 14px"
									alt="Fast filling job indicator"
								/>
								<span class="ml-1 fam-lato fw-M" style="font-size: 11px"
									><i>Fast Filling Job</i></span
								>
							</div>
							<div
								id="hideinmobile"
								class="d-flex align-items-center fam-lato fw-R fs-13 text-lightgrey"
							>
								<img
									src="../../assets/newdesign/jobsearch/blueClock.svg"
									style="width: 14px"
									alt="Posted time"
								/>
								<span class="ml-1">{{ getPostedText(job) }}</span>
							</div>
							<div class="">
							
								<button
									class="border-0 bg-transparent p-0"
									aria-label="Bookmark this job"
									@click.stop="toggleJobBookmark(job)"
								>
									<img
										v-if="job.bookmarked"
										src="../../assets/newdesign/jobsearch/filledBookmark.svg"
										style="cursor: pointer"
										alt="Remove bookmark"
									/>
									<img
										v-else
										src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
										style="cursor: pointer"
										alt="Save job"
									/>
								</button>
							</div>
						</div>
					</div>

				
					<footer class="d-flex justify-content-between align-items-end">
						<div
							class="d-flex align-items-center job-match-info fam-mont fw-LM"
						>
							<div
								v-if="job.experienceRequired"
								class="d-flex align-items-center mr-2"
							>
								<img
									src="../../assets/newdesign/landing/Briefcase.svg"
									alt="Experience required"
								/>
								<dd class="ml-2 mb-0">
									{{ toSentenceCase(job.experienceRequired) }}
								</dd>
							</div>
							<span
								v-if="job.experienceRequired"
								class="dot-separator mr-2"
								aria-hidden="true"
								>&middot;</span
							>
							<div class="d-flex align-items-center mr-2">
								<img
									src="../../assets/newdesign/jdprogress/trans-fulltime.svg"
									alt="Job type"
								/>
								<dd class="ml-2 mb-0">{{ toSentenceCase(job.jobType) }}</dd>
							</div>
							<span class="dot-separator mr-2" aria-hidden="true"
								>&middot;</span
							>
							<div class="d-flex align-items-center">
								<img
									src="../../assets/newdesign/jobsearch/blueLocation.svg"
									alt="Job location"
								/>
								<dd class="ml-2 mb-0">{{ formatLocation(job.location) }}</dd>
							</div>
						</div>
						<div id="hideinmobile">
							<b-button
								v-if="!job.jobApplied && !job.addedByRecruiter"
								class="candash-addBtn-js"
								@click.stop="routeToJobDetails(job)"
							>
								Apply
								<img
									class="ml-2"
									src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
									style="width: 16px"
									alt="Apply arrow"
								/>
							</b-button>
							<b-button
								v-else
								class="candash-addBtn-js"
								style="padding: 4px 18px !important"
							>
								<img
									class="mr-2"
									src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
									alt=""
								/>
								Applied
							</b-button>
						</div>
					</footer>

					<div id="hideinlaptop" class="d-flex gap-2 mt-2">
						<span class="fam-mont fw-LM fs-10">Skills:</span>
						<p class="fam-mont fw-LM fs-10 text-lightgrey mb-0 text-truncate">
							{{ (job.skills || []).map((s) => toSentenceCase(s)).join(", ") }}
						</p>
					</div>
					<div
						class="hideinlaptop d-flex align-items-center justify-content-between"
					>
						<div
							class="d-flex align-items-center fam-mont fw-LM fs-10 mob-fs-10 text-lightgrey"
						>
							<img
								src="../../assets/newdesign/jobsearch/blueClock.svg"
								style="width: 14px"
								alt="Posted time"
							/>
							<span class="ml-1">{{ getPostedText(job) }}</span>
						</div>
						<div>
							<b-button
								v-if="!job.jobApplied && !job.addedByRecruiter"
								class="candash-addBtn-js"
								@click.stop="routeToJobDetails(job)"
							>
								Apply
								<img
									class="ml-2"
									src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
									style="width: 16px"
									alt="Apply arrow"
								/>
							</b-button>
							<b-button
								v-else
								class="candash-addBtn-js"
								style="padding: 4px 18px !important"
							>
								<img
									class="mr-2"
									src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
									alt=""
								/>
								Applied
							</b-button>
						</div>
					</div>
				</article>
			</div>
		</div>
		<div id="hideinlaptop">
			<HorizontalScroll
				:scrollContainerRef="jobsScrollEl"
				scrollContainerId="jobsScrollContainer"
				:dataList="jobsList"
				class="mb-3"
			/>
		</div>
	</b-container> -->
</template>
<script>
import { postJobSearch, toggleBookmark } from "../../utils/apiFunctions";
import { mapGetters } from "vuex";
import EventBus from "@/utils/EventBus";
import HorizontalScroll from "../fixedcomponents/HorizontalScroll.vue";
import toast from "../mixin/toast";
import sectionTrackingMixin from "@/tracking/mixins/sectionTrackingMixin";
import itemTrackingMixin from "@/tracking/mixins/itemTrackingMixin";
import { DASHBOARD_SECTIONS } from "@/tracking/config";
export default {
	name: "MyProfileJobs",
	components: { HorizontalScroll },
	mixins: [toast, sectionTrackingMixin, itemTrackingMixin],
	props: {
		sectionKey: {
			type: String,
			default: () => DASHBOARD_SECTIONS.JOBS_PANEL,
		},
	},
	data() {
		return {
			jobsList: [],
			isLoading: true,
			jobsScrollEl: null,
			isHovered: false,
			activeJobIndex: 0,
			swipeDirection: "right",
			canScrollLeft: false,
			canScrollRight: false,
		};
	},
	computed: {
		...mapGetters("candidateVUEX", {
			primaryCandidateInfo: "getPrimaryCandidateInfo",
		}),
		dotTrackStyle() {
			const DOT = 8;
			const PILL = 19;
			const GAP = 8;
			const VIEWPORT = DOT + GAP + PILL + GAP + DOT; // 51px — always shows 3 items
			const n = this.jobsList.length;
			const idx = this.activeJobIndex;

			// Total track width: n dots where 1 is a pill, rest are small dots, with (n-1) gaps
			const trackWidth = PILL + (n - 1) * DOT + (n - 1) * GAP;

			// Center of the active pill within the track (left edge of pill + half pill width)
			// Pills before idx: idx small dots + idx gaps
			const pillLeft = idx * DOT + idx * GAP;
			const pillCenter = pillLeft + PILL / 2;

			// Ideal translate: put pillCenter at viewport center
			let translate = VIEWPORT / 2 - pillCenter;

			// Clamp: never show empty space on left or right
			const minTranslate = VIEWPORT - trackWidth; // most negative (last item flush right)
			const maxTranslate = 0; // most positive (first item flush left)
			translate = Math.min(maxTranslate, Math.max(minTranslate, translate));

			return { transform: `translateX(${translate}px)` };
		},
	},
	mounted() {
		window.addEventListener("resize", this.updateScrollArrows);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.updateScrollArrows);
		EventBus.$off("login-success", this.fetchRecommendedJobs);
		EventBus.$off("onboarding-fetch-post-login", this.fetchRecommendedJobs);
	},
	async created() {
		EventBus.$on("login-success", this.fetchRecommendedJobs);
		EventBus.$on("onboarding-fetch-post-login", this.fetchRecommendedJobs);
		await this.fetchRecommendedJobs();
	},
	methods: {
		async fetchRecommendedJobs() {
			this.isLoading = true;
			try {
				const candidateProfile = this.primaryCandidateInfo || {};
				const skills = Array.isArray(candidateProfile.skills)
					? candidateProfile.skills
							.map((item) => item.skillName || item.skill || item.name)
							.filter(Boolean)
					: [];

				// const payload = {
				// 	count: 3,
				// 	dateOfPosting: 0,
				// 	experiernce: [],
				// 	jobApplied: false,
				// 	jobType: [],
				// 	locations: [],
				// 	page: 0,
				// 	searchQuery: "",
				// 	sortBy: {
				// 		column: "relevance",
				// 		order: "-1",
				// 	},
				// 	skillSet: skills,
				// 	govtJobs: false,
				// };

				const payload = {
					sortBy: {
						column: "relevance",
						order: "-1",
					},
					dateOfPosting: null,
					experience: [],
					workType: [],
					jobType: [],
					minSalary: null,
					maxSalary: null,
					customerID: [],
					industry: [],
					qualifications: [],
					noticePeriod: null,
					companyType: null,
					locationsArray: [],
					latitude: null,
					longitude: null,
					searchQuery: "",
					locations: "",
					jobID: "",
					bookmarked: null,
					// skillSet: skills,
					page: 0,
					jobApplied: false,
					count: 10,
					home: true,
				};

				const res = await postJobSearch(payload);
				if (res && res.status === 200) {
					this.jobsList = Array.isArray(res.data?.data?.data)
						? res.data.data.data
						: [];
				}
			} catch (error) {
				console.log("Recommended jobs API error", error);
				this.jobsList = [];
			} finally {
				this.isLoading = false;
				this.$nextTick(() => {
					this.jobsScrollEl = this.$refs.jobsScrollContainer || null;
					this.updateScrollArrows();
				});
			}
		},
		toSentenceCase(value) {
			if (value === null || value === undefined) return "";
			const str = String(value).trim();
			if (!str) return "-";
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		formatLocation(location) {
			if (!Array.isArray(location) || !location.length) return "";
			return location
				.slice(0, 2)
				.map((item) => this.toSentenceCase(item))
				.join(", ");
		},
		getPostedText(job) {
			if (!job?.createdAt) return "Posted recently";
			const created = new Date(job.createdAt).getTime();
			const now = Date.now();
			const days = Math.max(0, Math.floor((now - created) / 86400000));
			return `Posted ${days} day${days === 1 ? "" : "s"} ago`;
		},
		async toggleJobBookmark(job) {
			if (!job?.jobID) return;
			const bookmarked = !job.bookmarked;
			job.bookmarked = bookmarked;
			try {
				const res = await toggleBookmark({
					jobID: job.jobID,
					bookmark: bookmarked,
				});
				if (res?.status === 200) {
					this.successModal(
						"Success",
						bookmarked ? "Bookmarked Successfully" : "Unbookmarked Successfully"
					);
				}
			} catch (error) {
				job.bookmarked = !bookmarked;
				console.log("Bookmark API error", error);
			}
		},
		onJobsScroll() {
			this.updateScrollArrows();
			const container = this.$refs.jobsScroll;
			if (!container) return;
			const card = container.querySelector(".nlp-job-cards");
			if (!card) return;
			const step = card.getBoundingClientRect().width + 16;
			const atEnd =
				container.scrollLeft + container.clientWidth >=
				container.scrollWidth - 2;
			const rawIndex = Math.round(container.scrollLeft / step);
			const newIndex = atEnd ? this.jobsList.length - 1 : rawIndex;
			if (newIndex !== this.activeJobIndex) {
				this.swipeDirection = newIndex > this.activeJobIndex ? "right" : "left";
				this.activeJobIndex = newIndex;
			}
		},
		centerActiveDot() {
			const wrap = this.$refs.dotTrack;
			const activeDot = this.$refs["dot-" + this.activeJobIndex];
			if (!wrap || !activeDot) return;
			const dot = Array.isArray(activeDot) ? activeDot[0] : activeDot;
			if (!dot) return;
			const wrapCenter = wrap.offsetWidth / 2;
			const dotCenter = dot.offsetLeft + dot.offsetWidth / 2;
			wrap.scrollTo({ left: dotCenter - wrapCenter, behavior: "smooth" });
		},
		updateScrollArrows() {
			const container = this.$refs.jobsScroll;
			if (!container) {
				this.canScrollLeft = false;
				this.canScrollRight = false;
				return;
			}
			const tolerance = 2;
			this.canScrollLeft = container.scrollLeft > tolerance;
			this.canScrollRight =
				container.scrollLeft + container.clientWidth <
				container.scrollWidth - tolerance;
		},
		scrollJobs(direction) {
			const container = this.$refs.jobsScroll;
			if (!container) return;
			const card = container.querySelector(".nlp-job-cards");
			if (!card) return;
			// Use getBoundingClientRect for exact rendered width including gap
			const cardRect = card.getBoundingClientRect();
			const gap = 16;
			const step = cardRect.width + gap;
			const scrollAmount = direction === "right" ? step : -step;
			container.scrollBy({ left: scrollAmount, behavior: "smooth" });
		},
		routeToJobDetails(job) {
			if (!job?.jobID) return;
			this.trackOnce("job_viewed", job.jobID, { jobID: job.jobID });
			this.$router.push({
				name: "JobSearch",
				query: { jobID: job.jobID },
			});
		},
		onApplyClick(job) {
			if (!job?.jobID) return;
			this.trackEvent("job_apply_intent", { jobID: job.jobID });
			this.$router.push({
				name: "JobSearch",
				query: { jobID: job.jobID },
			});
		},
	},
};
</script>
<style lang="scss">
.jobs-container {
	background-color: #ffffff;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	padding: 16px;
	max-width: 100%;
}
.dotted-bottom {
	border-bottom: 2px dashed #e2e8f0;
	padding-bottom: 16px;
}
.job-match-card {
	display: flex;
	border: 1px solid #e2ebf2;
	border-radius: 8px;
	background: #e5f1ff33;
	cursor: pointer;

	overflow: hidden;
}
.match-percentage-bar {
	background-color: #d1fae5;
	color: #047857;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;
	position: relative;
	width: 30px;
}
.calc-wid-1 {
	width: calc(100% - 311px);
}
.calc-wid-2 {
	width: calc(100% - 320px);
}
.match-percentage-text {
	transform: rotate(270deg);
	font-size: 12px;
	font-weight: 600;
	white-space: nowrap;
	letter-spacing: 1px;
}
.match-card-content {
	flex: 1;
	padding: 16px;
}
.job-match-title {
	font-size: 16px;
	color: #111827;
}
.match-comp {
	color: #4b5563;
}
.fast-filling-badge {
	background-color: #e0f2fe;
	color: #0284c7;
	padding: 2px 16px;
	border-radius: 8px;
	display: flex;
	align-items: center;
}

.job-match-info {
	font-size: 12px;
	color: #7a7a7a;
}
.dot-separator {
	color: #a0aec0;
	font-size: 16px;
	line-height: 1;
}
.match-comp {
	margin-top: 10px;
}
@media (min-width: 1028px) {
	.lapapplynow {
		width: calc(100% - 50px);
	}
}
@media (max-width: 1028px) {
	.jobs-container {
		padding: 16px 16px 0 16px;
	}
	.mob-hor-job-scroll {
		overflow-x: auto;
		width: 100%;
		padding-bottom: 10px;
		display: flex;
		gap: 16px;
	}
	.job-match-card {
		width: 310px;
		flex-shrink: 0;
	}
	.calc-wid-1 {
		width: 195px;
	}
	.calc-wid-2 {
		width: 240px;
	}
	.job-match-title {
		font-size: 13px;
		color: #20639b;
	}
	.match-comp {
		margin-top: 3px;
		margin-bottom: 7px;
	}
	.job-match-info {
		font-size: 10px;
	}
	.match-percentage-text {
		font-size: 10px;
		letter-spacing: 1px;
	}
	.match-percentage-bar {
		padding: 0 2px;
		width: 24px;
	}
	/* keep Apply Now + save icon inside the job card on narrow/zoomed screens */
	.nlp-job-cards .new-light-blue-btn {
		width: 100% !important;
		flex: 0 1 auto;
		min-width: 0;
	}
	.nlp-job-cards .jobcard-bookmark-container {
		flex-shrink: 0;
		margin-left: auto;
	}
}
.jobs-snap-scroll {
	scroll-snap-type: x mandatory;
}
.jobs-snap-item {
	scroll-snap-align: start;
}

/* sliding dot indicator */
.jobs-dot-viewport {
	width: 51px; /* DOT(8) + GAP(8) + PILL(19) + GAP(8) + DOT(8) */
	overflow: hidden;
	margin: 12px auto 0;
	display: flex;
	align-items: center;
	height: 28px;
}
.jobs-dot-track {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
	transition: transform 0.35s ease;
}
.jobs-dot {
	border-radius: 100px;
	flex-shrink: 0;
	transition: width 0.35s ease, min-width 0.35s ease, height 0.35s ease,
		background 0.35s ease, padding 0.35s ease;
	overflow: hidden;
	white-space: nowrap;
}
.jobs-dot--small {
	width: 8px;
	height: 8px;
	background: #cecece;
	min-width: 8px;
}
.jobs-dot--active {
	min-width: 19px;
	width: 19px;
	height: 8px;
	background: #333333;
	// color: #ffffff;
	// font-family: "Montserrat", sans-serif;
	// font-size: 12px;
	// font-weight: 600;
	// display: inline-flex;
	// align-items: center;
	// justify-content: center;
	// padding: 0 12px;
}
.jc-white-tags {
	padding: 2px 8px;
	background: #ffffff;
	border: 1px solid rgba(241, 241, 241, 0.4);
	border-radius: 32px;
	white-space: nowrap;
}
.company-name,
.location-name {
	min-width: 0;
	max-width: 40%;
	flex: 0 1 auto;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.company-location-dot {
	width: 6px;
	height: 6px;
	background: #6573a2;
	border-radius: 100px;
	margin: 0 5px;
	flex-shrink: 0;
}
.jobs-icon-container {
	width: 44px;
	height: 44px;
	background: #ffffff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px -5.01923px 12.5481px rgba(255, 255, 255, 0.9),
		0px 10.0385px 25.0962px rgba(0, 0, 0, 0.1);
	border-radius: 40.1538px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.w-20 {
	width: 20%;
}
</style>
